module.exports = __webpack_public_path__ + "img/cb-chaneel-no.399bac79.svg";